export default "\n{% block sw_admin_menu_navigation_main %}\n{% parent %}\n\n<sw-sales-channel-menu v-if=\"canViewSalesChannels\" />\n{% endblock %}\n";